import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';
import { sheetDownload } from '../../shared/fileDownload';
import modelo from '../../assets/images/modelo_importacao_puntu.xlsx'

export const uploadFile = file => (dispatch) => {
  dispatch(setLoading(true));
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post('/import/employees/xlsx', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const uploadAfdFileAFD1510 = file => (dispatch) => {
  dispatch(setLoading(true));
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post('import/importAFD1510?type=AFD', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Registros importados com sucesso! Gerencie em acompanhamento'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const uploadAfdFileAFD671 = file => (dispatch) => {
  dispatch(setLoading(true));
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post('import/importAFD671?type=AFD', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Registros importados com sucesso! Gerencie em acompanhamento'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const uploadFingerPrint = file => (dispatch) => {
  dispatch(setLoading(true));
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post('import/importTxt', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Registros importados com sucesso! Gerencie em acompanhamento'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const exportAEJ = file => (dispatch) => {
  dispatch(setLoading(true));
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post('import/importTxt', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Registros importados com sucesso! Gerencie em acompanhamento'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};


export const downloadModel = () => () => {
  sheetDownload(modelo, 'modelo_importacao.xlsx');
};


